import { translate } from './convertToLocalEnglish/internals/translate';

export const convertToLocalEnglish = (input: string) => {
  const locale = navigator.language;

  if (locale === 'en-US') {
    return translate(input, { american: true });
  }
  return translate(input);
};
